<template>
<v-container grid-list-xs>
  <v-dialog
    v-if="transfer.dialog"
    v-model="transfer.dialog"
    max-width="500px"
    transition="dialog-transition"
  >
    <v-card style="border-radius:12px">
      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Transferir fundos para Banco</h3>
          <div class="caption">Esta operação gera taxa de TED pelo PagarMe de R$ {{transfer.fee}}</div>
        </div>
      </v-card-title>
      <v-form ref="formTransfer" lazy-validation>
        <v-card-text>
          <template v-if="format(transfer.ammount) > transfer.fee">
            <card-loading v-if="transfer.loading" loadText="Enviando requisição de transferência"></card-loading>
            <v-text-field v-model="transfer.ammount" v-currency="currency" :rules="[transfer.rules.required, transfer.rules.notZero ]" label="Valor" prepend-icon="mdi-currency-brl" ></v-text-field>
          </template>
          <template v-if="!(format(transfer.ammount) > transfer.fee)">
            <v-alert type="info" align="center" :value="true">
              <div class="headline">Não há fundos para transferir!!</div>
            </v-alert>

          </template>
        </v-card-text>
      </v-form>

      <v-card-actions class="justify-end">
        <v-btn text color="error" @click="transfer.dialog = false">Cancelar</v-btn>
        <v-btn text color="primary" v-if="format(transfer.ammount) > transfer.fee" @click="transfer_funds(transfer.ammount)">OK</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
  <v-card style="border-radius:12px">
    <v-card-title primary-title>
      <div>
        <h3 class="headline mb-0">Saldo PagarMe</h3>
      </div>
      <v-spacer></v-spacer>
      <v-tooltip bottom v-for="(item, idx) in items" :key="'btn2'+idx">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" :disabled="item.disabled" fab color="primary" class="mx-2 elevation-3 white--text" @click="item.action()/*buton_actions(item.action)*/" >
            <v-icon large>{{item.icon}}</v-icon>
          </v-btn>
        </template>

        {{item.title}}
      </v-tooltip>
    </v-card-title>
    <v-card-text>


    <v-row justify="space-around">
      <v-col v-for="(item,idx) in balance" :key="`cardBalance-${idx}`" cols="12" sm="6" lg="4">

      <v-card outlined style="border-radius: 8px;" :color="item.color +' lighten-2'">
        <v-row align="center">
        <v-col cols="2" style="border-radius: 8px;" :class="`${item.color} darken-4 display-1 pa-2 `" align="center">
          <v-icon color="grey lighten-5"> mdi-36px mdi-currency-brl</v-icon>
        </v-col>
        <v-col>
          <div :class="['caption',item.color+'--text text--darken-4 ml-2']">{{item.description}}</div>
          <div v-if="item.amount != null" :class="`${item.color}--text text--darken-4 display-2  ml-2`"><h4>{{item.amount | toCurrency}}</h4></div>
          <div v-if="item.amount == null" :class="`${item.color}--text text--lighten-4 display-2 ml-2`">****.**</div>

        </v-col>
        </v-row>
        <v-progress-linear v-if="item.amount == null" :color="`${item.color} darken-4 mr-3`" indeterminate rounded height="6"></v-progress-linear>
      </v-card>
      </v-col>

    </v-row>
    <!-- </v-container> -->
    </v-card-text>

  </v-card>
</v-container>
</template>

<script>
import Api from '../../api'
import { CurrencyDirective, parseCurrency } from 'vue-currency-input'

// import { mask } from 'vue-the-mask'

export default {
  name: 'GatewayBalance',
  // components: { CurrencyInput },

  directives:{
    // mask
    currency: CurrencyDirective
  },

  data() {
    return {
      balance:{
        available: {amount: null, icon: "", color: "green", description: "Disponível" },
        waiting_funds: {amount: null, icon: "", color: "orange", description: "Aguardando Fundos" },
        transferred: {amount: null, icon: "", color: "blue", description: "Transferido" }
      },

      items: [
        { title: 'Boletos',          action: () => this.$router.push('/bills') , icon: 'mdi-barcode', disabled: false},
        { title: 'Transferir Fundos',          action: () => this.transfer.dialog = true, icon: 'mdi-bank-transfer-in', disabled: false}
      ],

      transfer: {
        fee: 3.67,
        dialog: false,
        loading: false,
        ammount: 0,
        // mask: '########.##'
        rules: {
          required: v => !!v || 'Campo é necessário',
          notZero: v=> v != '0.00' || 'Não pode ser zero',
        },
      },

      currency:{
        currency: null,
        locale: 'pt-BR',
        autoDecimalMode: false,
        decimalLength: 2,
        distractionFree: false,
      },
    }

  },
  methods: {
    format(value) {
      if (typeof value === "number") {
        return value;
      } else {
        return parseCurrency(value, this.currency)
      }
    },
    getBalance() {
      Api.FinancialGatewayBalance.balance()
        .then(r=>r.data)
        .then(response=>{
          // Acessar os dados considerando a estrutura: response.data.available.amount
          const balance = response.data;
          this.balance.available.amount = balance.available.amount
          this.balance.waiting_funds.amount = balance.waiting_funds.amount
          this.balance.transferred.amount = balance.transferred.amount
          this.transfer.ammount = this.format(balance.available.amount)-this.transfer.fee

        }).catch(err=>{
          console.log('erro em index de bill');
          console.log({err});
        })

    },
    redirect_to_bills(){
      this.$router.push('/bills')
    },


    transfer_funds(ammount){
      if(this.$refs.formTransfer.validate()){
        this.transfer.loading = true
        Api.FinancialGatewayBalance.transfer(parseCurrency(ammount, this.currency)).then(r=>r.data)
          .then(response=>{
            // Atualizar o saldo após a transferência
            this.getBalance()
            this.transfer.loading = false
            this.transfer.dialog = false
            this.$swal({
              toast: true,
              position: 'top-end',
              timer: 3000,
              showConfirmButton: false,
              title: `Solicitação de transferência realizada com sucesso!`,
              type: "success",
              confirmButtonText: 'OK',
              confirmButtonColor: '#003a3e',
            })

          }).catch(err=>{
            console.log('Erro na requisição');
            this.transfer.loading = false
            console.log({err});
            this.$swal({
            toast: true,
            position: 'top-end',
            timer: 3000,
            showConfirmButton: false,
            title: `Falha na soliciação: ${err}`,
            type: "error",
            confirmButtonText: 'OK',
            confirmButtonColor: '#003a3e',
          })
          })
      }
    }
    // ...mapActions({
    //   // function: 'Module/action'
    // })
  },
  mounted () {
    this.getBalance()
  },

  computed: {
    name() {
      return null
    },
    // ...mapState({
    //   // data: state=> state.Module.state_var
    // })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>